import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/_nuxt3-static/events/star.svg")